"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const graphql_1 = require("..");
// export const createContentConversionStep = graphqlTag`
//   mutation createContentConversionStep($contentConversionId: ID!, $data: ContentConversionStepInput!) {
//     createContentConversionStep(contentConversionId: $contentConversionId, data: $data) {
//       ...contentConversionStepDetailData
//     }
//   }
//   ${contentConversionStepDetailData}
// `;
exports.createOrUpdateConversionStep = graphql_tag_1.default `
  mutation createOrUpdateConversionStep(
      $id: ID,
      $contentConversionId: ID!,
      $data: ContentConversionStepInput!
    ) {
    createOrUpdateConversionStep(
      id: $id,
      contentConversionId: $contentConversionId,
      data: $data
    ) {
      ...contentConversionStepDetailData
    }
  }
  ${graphql_1.contentConversionStepDetailData}
`;
// createOrUpdateConversionStep;
// export const updateContentConversionStep = graphqlTag`
//   mutation updateContentConversionStep(
//     $id: ID!,
//     $data: ContentConversionStepInput!,
//     $contentConversionId: ID!
//   ) {
//     updateContentConversionStep(
//       id: $id,
//       data: $data,
//       contentConversionId: $contentConversionId
//     ) {
//       ...contentConversionStepDetailData
//     }
//   }
//   ${contentConversionStepDetailData}
// `;
exports.reorderContentConversionSteps = graphql_tag_1.default `
  mutation reorderContentConversionSteps($ids: [ID!]!, $orderBy: String) {
    reorderContentConversionSteps(ids: $ids, orderBy: $orderBy) {
      ...contentConversionStepDetailData
    }
  }
  ${graphql_1.contentConversionStepDetailData}
`;
//# sourceMappingURL=contentConversionSteps.js.map